
import React from 'react'
import Box from './Box'

/**
 * Dialog component.
 */

export default function Spacer({ y = 0, x = 0 }) {
  return <Box marginTop={y} marginLeft={x} />
}
